import { Component, AfterViewInit, AfterViewChecked, NgZone, OnDestroy, ViewChild, ChangeDetectorRef, ViewEncapsulation, PACKAGE_ROOT_URL } from '@angular/core';
import { NgForm, FormGroup, FormControl, ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';

import { TdLoadingService, TdMediaService, TdDialogService, } from '@covalent/core';

import { Patron } from '../../../../../../models/';
import { MasterService, LoginService, PatronesService } from '../../../../../../services/';
import { Pregunta } from '../../../../../../models/pregunta';
import { MdOptionSelectionChange, MdDialog, MdCheckboxChange } from '@angular/material';
import { PreguntasObligatoriasComponent } from '../../../preguntasobligatorias/preguntasobligatorias.component';
import { AltaPatron } from '../../../../../../models/altaPatron';
import { strictEqual } from 'assert';
import { formGroupNameProvider } from '@angular/forms/src/directives/reactive_directives/form_group_name';
import { stringify } from '@angular/core/src/util';

@Component({
  selector: 'qs-altapatron',
  styleUrls: ['./altapatron.component.scss'],
  templateUrl: './altapatron.component.html',
  viewProviders: [PatronesService],
  encapsulation: ViewEncapsulation.None,
})

export class AltaPatronComponent implements AfterViewInit, AfterViewChecked, OnDestroy {
  private patrones: Patron[];
  private preguntasExcluyentes: any;
  public altaPatronForm: AltaPatron;
  public patron: any;
  public title: string;
  public testForm: NgForm;
  public titulo: string;
  public idPaciente: string;
  public texto: string;
  // public testForm: NgForm;
  public idPatron: string;
  public sexoPaciente: string;
  public edadPaciente: string;
  public tipoEdad: string;
  public sub: any;
  public test: Patron[] = [];
//  public preguntas: Pregunta[] = [];

  //  private idRespuesta: string;
  // public preguntas: Pregunta[];
  public agrupaciones: { agrupacion: any; }[];
  public agrupacion: any;
  public size: any;
  public idValoracion: any;

  constructor(private _loadingService: TdLoadingService,
    public media: TdMediaService,
    private _dialogService: MdDialog,
    private _router: Router,
    private _route: ActivatedRoute,
    private _patronesService: PatronesService,
    private _loginService: LoginService,
    private _ngZone: NgZone,
    private _changeDetectorRef: ChangeDetectorRef) {

  }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this.idPatron = this.patron.id;
    this.title = this.titulo;
    this._loadingService.register('altapatron.load');
    this._changeDetectorRef.detectChanges();

    this.sexoPaciente = this._loginService.consulta.sexo;
    let age: any = this._loginService.consulta.edad;
    let splitted: any = age.split(' ', 2);
    this.edadPaciente = splitted[0];
    let tEdad: any = splitted[1];
    this.tipoEdad = tEdad.charAt(0);

    this._patronesService.obtenerPreguntasRespuestasPatron( this.idPatron, this.sexoPaciente, '-1', '-1', this.tipoEdad)
    .subscribe((res: any) => {

      this.patron = res.respuesta;

      this.agrupaciones = res.respuesta.agrupaciones;
      this.preguntasExcluyentes = res.respuesta.preguntasExcluyentes;

      this.agrupacion = this.agrupaciones[0].agrupacion;

      if (this.agrupaciones.length > 1) {
        this.size = true;
      } else {
        this.size = false;
      }

      this._loadingService.resolve('altapatron.load');
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error obteniendo motivos de consulta.', 'OK', 6000);
      this._loadingService.resolve('patronesdisponibles.load');
    });

  }

  /**
   * FIX: Esto es un fix para ExpressionChangedAfterItHasBeenCheckedError
   * Aparece al cargar un componente de la vista con datos desde un servicio
   */
  ngAfterViewChecked(): void {
    this._changeDetectorRef.detectChanges();
  }

  // delete(form: NgForm): void {
  //   this.mode = 'del';
  //   this.save(form);
  // }

  save(form: NgForm): void {
    // console.log(form);
    let validado: boolean;
    let fecha: Date = new Date();
    let hora: string = fecha.getHours() + ':' + fecha.getMinutes() + ':' + fecha.getSeconds();
    // this.idValoracion;
    validado = this.verificarPreguntaObligatoria();

    if (!validado) {
      this.openDetail();
    } else {
    // if (form.valid) {
      this._loadingService.register();
      let params: any = {
        idPatron: this.idPatron,
        idValoracion: this.idValoracion,
        textoPatron: this.title,
        numExpediente: this.idPaciente,
        fechaCumplimentacion: fecha,
        dniMedico: this._loginService.profesional.Dni,
        numVisita: this._loginService.consulta.visita,
        tipoEdad: this.tipoEdad,
        itemsPatron: this.agrupaciones,
      };

      let jparams: any = JSON.stringify(params);

      this._patronesService.HCI_OnCloud_InsertarDatosParaPatronCumplimentado(jparams)
      .subscribe((res: any) => {
        if (res) {
          this._loginService.patron = res;
          this._loginService.mostrarMensaje('Patrón añadido correctamente.', 'OK', 6000);
          if (this._loadingService.resolve()) {
            this.close();
          }
          this._router.navigate(['/main/consulta/' + this.idPaciente + '/modanamnesis', { outlets: { modanamnesis: ['patronesfuncionales'] } }]);
        } else {
          this._loginService.mostrarMensaje('Error añadiendo patrón.', 'OK', 6000);
          this._loadingService.resolve();
        }
      }, (resError: Error) => {
        this._loginService.mostrarMensaje('Error procesando el alta', 'OK', 6000);
        this._loadingService.resolve();
      });
    }
    this._loadingService.resolve();

  }

  openDetail(): void {
    let dialogRef: any = this._dialogService.open( PreguntasObligatoriasComponent, {
      id: '11',
      width: '60%',
      role: 'dialog',
      height: '22%',
    });

  }

  close(): void {
    this._dialogService.closeAll();
  }

  ngOnDestroy(): void {
    this._loginService.transient = '';
  }

  actualizaRespuesta(event: MdOptionSelectionChange, idRespuesta: String, idPregunta: String): void {
    if (event.source.selected) {
      for (let grupo in this.agrupaciones) {
        this.agrupacion = this.agrupaciones[grupo].agrupacion;
        for ( let pregunta in this.agrupacion) {
          // tslint:disable-next-line: triple-equals
          if (this.agrupacion[pregunta].idPregunta === idPregunta) {
            for (let respuesta in this.agrupacion[pregunta].respuestas) {
              if (this.agrupacion[pregunta].respuestas[respuesta].idRespuesta !== idRespuesta) {
                this.agrupacion[pregunta].respuestas[respuesta].seleccionada = false;
              }
              if (this.agrupacion[pregunta].respuestas[respuesta].idRespuesta === idRespuesta) {
                this.agrupacion[pregunta].respuestas[respuesta].seleccionada = true;
              }
            }
            break;
          }
        }
      }
      this.excluyePregunta(idRespuesta, idPregunta);
    }
  }

  actualizaRespuestaMultiple(event: MdCheckboxChange, idRespuesta: String, idPregunta: String): void {
    if (event.source.change) {
      for (let grupo in this.agrupaciones) {
        this.agrupacion = this.agrupaciones[grupo].agrupacion;
        for ( let pregunta in this.agrupacion) {
          if (this.agrupacion[pregunta].idPregunta === idPregunta) {
            for (let respuesta in this.agrupacion[pregunta].respuestas) {
              if (this.agrupacion[pregunta].respuestas[respuesta].idRespuesta === idRespuesta) {
                if (this.agrupacion[pregunta].respuestas[respuesta].seleccionada === true) {
                  this.agrupacion[pregunta].respuestas[respuesta].seleccionada = false;
                } else {
                  this.agrupacion[pregunta].respuestas[respuesta].seleccionada = true;
                }
              }
            }
          }
        }
      }
      this.excluyePregunta(idRespuesta, idPregunta);
    }
  }

  actualizaRespuestaTexto(inputValue: String, idPregunta: String): void {

      for (let grupo in this.agrupaciones) {
        this.agrupacion = this.agrupaciones[grupo].agrupacion;
        for ( let pregunta in this.agrupacion) {
          if (this.agrupacion[pregunta].idPregunta === idPregunta) {
            if (inputValue !== '') {
              this.agrupacion[pregunta].respuestas[0].idRespuesta = inputValue;
              this.agrupacion[pregunta].respuestas[0].seleccionada = true;
              break;
            } else {
              this.agrupacion[pregunta].respuestas[0].idRespuesta = undefined;
              this.agrupacion[pregunta].respuestas[0].seleccionada = false;
              break;
            }
          }
        }
      }
  }

  actualizarFecha(inputValue: Date, idPregunta: String): void {
    let fecha: any = this.dateFormat(inputValue);
    for (let grupo in this.agrupaciones) {
      this.agrupacion = this.agrupaciones[grupo].agrupacion;
      for ( let pregunta in this.agrupacion) {
        if (this.agrupacion[pregunta].idPregunta === idPregunta) {
          this.agrupacion[pregunta].respuestas[0].idRespuesta = inputValue.toLocaleDateString();
          this.agrupacion[pregunta].respuestas[0].seleccionada = true;
        }
      }
    }
  }

  excluyePregunta(idRespuesta: String, idPregunta: String): void {
    for (let grupo in this.agrupaciones) {
      this.agrupacion = this.agrupaciones[grupo].agrupacion;
      for (let pregunta in this.agrupacion) {
        if (this.agrupacion[pregunta].idPregunta === idPregunta) {
          for (let preguntaExcluyente in this.preguntasExcluyentes) {
            if ((idPregunta === this.preguntasExcluyentes[preguntaExcluyente].MREX_IDPREGUNTA) &&
            (idRespuesta !== this.preguntasExcluyentes[preguntaExcluyente].MREX_IDRESPUESTAS)) {
                for (let preguntaNoExcluir in this.agrupacion) {
                  if (this.agrupacion[preguntaNoExcluir].idPregunta === this.preguntasExcluyentes[preguntaExcluyente].MREX_IDPREGUNTAEXCLUYE) {
                    this.agrupacion[preguntaNoExcluir].esExcluida = false;
                    this.agrupacion[preguntaNoExcluir].excluida = 'mostrar';
                  }
                }

            }
            if ((idPregunta === this.preguntasExcluyentes[preguntaExcluyente].MREX_IDPREGUNTA) &&
            (idRespuesta === this.preguntasExcluyentes[preguntaExcluyente].MREX_IDRESPUESTAS)) {
              for (let preguntaAExcluir in this.agrupacion) {
                if (this.agrupacion[preguntaAExcluir].idPregunta === this.preguntasExcluyentes[preguntaExcluyente].MREX_IDPREGUNTAEXCLUYE) {
                  this.agrupacion[preguntaAExcluir].esExcluida = true;
                  this.agrupacion[preguntaAExcluir].excluida = 'ocultar';
                }
              }
            }
          }
        }
      }
    }
  }

  verificarPreguntaObligatoria(): boolean {
    let validado: any = true;
    for (let grupo in this.agrupaciones) {
      let agrupacion: any = this.agrupaciones[grupo].agrupacion;
      for (let pregunta in agrupacion) {
        if (agrupacion[pregunta].obligatoria === 'S') {
          let respuestas: any = agrupacion[pregunta].respuestas;
          let preguntaActualizada: any = false;
          for (let respuesta in respuestas) {
            if (respuestas[respuesta].seleccionada === true) {
              agrupacion[pregunta].contestada = true;
              preguntaActualizada = true;
            }
          }
          if (agrupacion[pregunta].contestada === false && preguntaActualizada === false) {
            validado = false;
          }
          if (agrupacion[pregunta].contestada === true && preguntaActualizada === false) {
            agrupacion[pregunta].contestada = false;
            validado = false;
          }
        }
      }
    }
    return validado;
  }

  dateFormat(date: Date): String {
    let auxDate: any = date.toLocaleDateString();
    let secc: any = auxDate.split('/');
    let dia: any;
    let mes: any;
    let fecha: any;
    if ( secc[0].length === 1 ) {
        dia = '0' + secc[0].charAt(0);
    } else {
        dia = secc[0];
    }
    if ( secc[1].length === 1 ) {
        mes = '0' + secc[1].charAt(0);
    } else {
        mes = secc[1];
    }
    fecha = dia + '/' + mes + '/' + secc[2];

    return fecha;
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/modanamnesis/patronesfuncionales/patronesdisponibles/altapatron/altapatron.component.ts